import LayoutMain from 'components/layouts/LayoutMain';
import LayoutLogin from 'components/layouts/LayoutLogin';
import Error404 from 'pages/admin/Error404';

export const mainRoute = (path, element) => ({
  path,
  layout: LayoutMain,
  element,
});

export const loginRoute = (path, element) => ({
  path,
  layout: LayoutLogin,
  element,
});

export const catchAllRoute = () => mainRoute('/*', Error404);
